import type { TFunction } from "i18next";

export type FieldSourceDetails = { kind: string } & Record<string, unknown>;

export const trimmedText = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value.trim() : null;

export const describeFieldSource = (
  t: TFunction,
  { kind, ...details }: FieldSourceDetails,
  libraryTitle: (details: Record<string, unknown>) => string | null,
): string | null => {
  const named = (label: string, title: unknown) => [label, trimmedText(title)].filter(Boolean).join(": ");
  switch (kind) {
    case "USER_ANSWER":
      return t("Your answer in the conversation");
    case "UPLOADED_DOCUMENT": {
      const where =
        typeof details.page === "number" ? t("page {{page}}", { page: details.page }) : trimmedText(details.section);
      return trimmedText(details.fileName) && where ? `${trimmedText(details.fileName)}, ${where}` : null;
    }
    case "REQUIREMENT_LIBRARY": {
      const title = libraryTitle(details);
      return title ? named(t("Requirement library"), title) : null;
    }
    case "EARLIER_PROCUREMENT":
      return trimmedText(details.sourcingEventId) ? named(t("Earlier procurement"), details.title) : null;
    case "EARLIER_CONTRACT":
      return trimmedText(details.contractId) ? named(t("Earlier contract"), details.title) : null;
    case "NEED":
      return trimmedText(details.needId) ? named(t("Need"), details.title) : null;
    case "PRODUCT_RULES":
      return named(t("The procurement rules"), details.rule);
    default:
      return null;
  }
};
